import React from "react";
import { IAboutDescriptionData } from "../../exports/interfaces";
import { Fade } from "react-awesome-reveal";

const AboutDescription = (props: {
  aboutDescriptionData: IAboutDescriptionData[];
}) => {
  return (
    <section className="about-page">
      <div className="container">
        <div className="row">
          <div className="col-xl-6">
            <div
              className="about-page__left wow slideInLeft"
              data-wow-delay="100ms"
              data-wow-duration="2500ms"
            >
              <Fade cascade damping={0.2} delay={1200} direction="left" triggerOnce={true}>
                <div className="about-page__img">
                  <img
                    src={`${process.env.REACT_APP_strapiUrl}${props?.aboutDescriptionData[0]?.attributes?.Image?.data?.attributes?.url}`}
                    alt="about-image"
                    style={{
                      objectFit: "cover",
                      width: "100%",
                      height: "498px",
                    }}
                  />
                </div>
              </Fade>
            </div>
          </div>
          <div className="col-xl-6">
            <div className="about-page__right">
              <div className="section-title text-left">
                <span className="section-title__tagline">
                  {props?.aboutDescriptionData[0]?.attributes?.Primary_Title}
                </span>
                <h2 className="section-title__title">
                  {props?.aboutDescriptionData[0]?.attributes?.Secondary_Title}
                </h2>
              </div>
              <p className="about-page__text" style={{ textAlign: "justify" }}>
                {props?.aboutDescriptionData[0]?.attributes?.Description}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutDescription;
